import { render, staticRenderFns } from "./OtaruRegisterDestroyDialog.vue?vue&type=template&id=6bdc8ceb&scoped=true&"
import script from "./OtaruRegisterDestroyDialog.vue?vue&type=script&lang=ts&"
export * from "./OtaruRegisterDestroyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OtaruRegisterDestroyDialog.vue?vue&type=style&index=0&id=6bdc8ceb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdc8ceb",
  null
  
)

export default component.exports